import React from 'react';
import { SkyLightStateless } from 'react-skylight';

const defaultStyles = {
  minHeight: 100,
  justifyContent: 'space-between',
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '10px',
};
export default function Modal({
  children,
  isVisible,
  onClose,
  title,
  dialogStyles,
  tiny,
  small,
  medium,
  large,
  massive,
  modalProps,
}) {
  dialogStyles = {
    ...defaultStyles,
    ...dialogStyles,
  };
  if (tiny) {
    dialogStyles.height = '100px';
    dialogStyles.marginTop = '-50px';
    dialogStyles.width = '200px';
    dialogStyles.marginLeft = '-100px';
  } else if (small) {
    dialogStyles.height = '200px';
    dialogStyles.marginTop = '-100px';
    dialogStyles.width = '350px';
    dialogStyles.marginLeft = '-175px';
  } else if (medium) {
    dialogStyles.height = '500px';
    dialogStyles.marginTop = '-250px';
    dialogStyles.width = '400px';
    dialogStyles.marginLeft = '-200px';
  } else if (large) {
    dialogStyles.height = '700px';
    dialogStyles.marginTop = '-350px';
    dialogStyles.width = '800px';
    dialogStyles.marginLeft = '-400px';
  } else if (massive) {
    dialogStyles = {
      ...dialogStyles,
      height: '100vh',
      width: '100vw',
      left: 0,
      top: 0,
      borderRadius: 0,
      marginLeft: 0,
      marginTop: 0,
      padding: 0,
    };
  }
  return (
    <SkyLightStateless
      dialogStyles={dialogStyles}
      isVisible={isVisible}
      onCloseClicked={onClose}
      title={title}
      {...modalProps}
    >
      {children}
    </SkyLightStateless>
  );
}

Modal.defaultProps = {
  dialogStyles: {},
  modalProps: {},
};
